const roundOffTotal = (value, roundOffType) => {

    switch (roundOffType) {
        case "standardRoundOff":          
            return Math.round(value);
        
        case "lowerRoundOff": 
            return Math.floor(value);
        
        case "upperRoundOff":
            return Math.ceil(value);
        
        default:
            return value;
    };
}
export default roundOffTotal;
  